import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, Label, Row } from "reactstrap";
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
  getIndustryData,
  getStaff,
  getUserList,
  showEnquiry,
  updateEnquiry,
} from "../../../CommonURL";

import {
  getDataWithToken,
  postDataWithToken,
} from "../../../Utils/restUtils";

import Typeahead from "../../../CommonElements/TypeAhead";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import Transparentspinner from "../../Common/loader/Transparentspinner";

import { toast } from "react-toastify";

import Select from "react-select";

import { Country, State } from "country-state-city";

import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/style.css";

import IndustryFilter from "../../Common/Filters/IndustryFilter";

const EditEnquiry = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const enquiryId = searchParams.get("id");

  const [loading, setLoading] = useState(false);

  const [selectedCountry, setSelectedCountry] = useState(null);

  const [stateOptions, setStateOptions] = useState([]);

  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const [userOption, setUserOption] = useState([]);

  const [staffOptions, setStaffOptions] = useState([]);

  const [customerType, setCustomerType] = useState("new");

  const customerTypeOptions = [
    { value: "new", label: "New Customer" },
    { value: "existing", label: "Existing Customer" },
  ];

  const enquiryStatusOptions = [
    { value: "new", label: "New" },
    { value: "contacted", label: "Contacted" },
    { value: "qualified", label: "Qualified" },
    { value: "lost", label: "Lost" },
    { value: "converted", label: "Converted" },
  ];

  const sourceOptions = [
    { value: "website", label: "Website" },
    { value: "walk_in", label: "walk_in" },
    { value: "whatsapp", label: "whatsapp" },
    { value: "referral", label: "referral" },
    { value: "other", label: "other" },
  ];

  const schema = Yup.object()
    .shape({
      name: Yup.string().when([], {
        is: () => customerType === "new",
        then: (schema) => schema.required("Name is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      phone: Yup.string().when([], {
        is: () => customerType === "new",
        then: (schema) => schema.required("Phone number is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      existingCustomer: Yup.mixed().when([], {
        is: () => customerType === "existing",
        then: (schema) => schema.required("Existing customer is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

      source: Yup.mixed().required("Source is required"),

      industry: Yup.mixed().required("Industry is required"),
    })
    .required();

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),

    defaultValues: {
      country_code: "",
      country: "",
      state: "",
      phone: "",
    },
  });

  useEffect(() => {
    getIndustryList();
    getUsersList();
    getStaffList();

    if (enquiryId) {
      getEnquiryDetails();
    }
  }, []);

  const getIndustryList = async () => {
    await getDataWithToken(getIndustryData);
  };

  const getStaffList = async () => {
    try {
      const res = await getDataWithToken(getStaff);

      const apiData = res?.data?.data || [];

      const options = apiData.map((item) => ({
        value: item.id,
        label: `${item.first_name} ${item.last_name}`,
      }));

      setStaffOptions(options);
    } catch (error) {
      console.log(error);
    }
  };

  const getUsersList = async (industryId = "") => {
    const response = await getDataWithToken(
      `${getUserList}?industry_type_id=${industryId}`
    );

    if (response?.data?.data) {
      const options = response.data.data.map((item) => ({
        value: item.id,
        label: item.user_name,
        phone: `+${item.country_code}${item.mobile}`,
        country_code: `+${item.country_code}`,
      }));

      setUserOption(options);
    }
  };

  const getEnquiryDetails = async () => {
    setLoading(true);

    try {
      const response = await getDataWithToken(
        `${showEnquiry}?enquiry_id=${enquiryId}`
      );
      console.log("response",response);
      

      if (response?.status === true) {
          const enquiryData = response.data.data[0];

        
      
        
        if (enquiryData) {
          // customer type
         if (enquiryData.customer_exist === true) {
            setCustomerType("existing");
            

            const existingCustomer = {
              value: enquiryData.user_id,
              label: enquiryData.name,
              phone: enquiryData.phone,
              country_code: enquiryData.country_code,
            };

            setValue("existingCustomer", existingCustomer);
          } else {
            setCustomerType("new");

            setValue("name", enquiryData.name || "");
            setValue(
              "phone",
              `${enquiryData.country_code || ""}${enquiryData.phone || ""}`
            );
          }

          // normal fields
          setValue("email", enquiryData.email || "");
          setValue("address", enquiryData.address || "");
          setValue("city", enquiryData.city || "");
          setValue("state", enquiryData.state || "");
          setValue("country", enquiryData.country || "");
          setValue("company", enquiryData.company || "");
          setValue("notes", enquiryData.notes || "");

          // source
          const sourceObj = sourceOptions.find(
            (item) => item.value === enquiryData.source
          );

          setValue("source", sourceObj);

          // status
          const statusObj = enquiryStatusOptions.find(
            (item) => item.value === enquiryData.status
          );

          setValue("status", statusObj);

          // industry
          const industryObj = {
            value: enquiryData.industry_type_id,
            label: enquiryData.industry_name,
          };

          setSelectedIndustry(industryObj);

          setValue("industry", industryObj);

          getUsersList(enquiryData.industry_type_id);

          // assigned user
          if (enquiryData.assigned_to) {
            const assignedObj = {
              value: enquiryData.assigned_to,
              label: enquiryData.assigned_user_name,
            };

            setValue("assignedTo", assignedObj);
          }

          // country
          const selected = Country.getAllCountries().find(
            (c) => c.name === enquiryData.country
          );

          if (selected) {
            setSelectedCountry(selected);

            setValue(
              "country_code",
              enquiryData.country_code || `+${selected.phonecode}`
            );

            const states = State.getStatesOfCountry(selected.isoCode);

            const formattedStates = states.map((item) => ({
              label: item.name,
              value: item.name,
            }));

            setStateOptions(formattedStates);
          }
        }
      }
    } catch (error) {
      console.log(error);

      toast.error("Failed to load enquiry details");
    }

    setLoading(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      const postRequest = {
        enquiry_id: enquiryId,

        country_code:
          customerType === "existing"
            ? data.existingCustomer?.country_code
            : data.country_code,

        name:
          customerType === "existing"
            ? data.existingCustomer?.label
            : data.name,

        user_id:
          customerType === "existing"
            ? data.existingCustomer?.value
            : "",

        phone:
          customerType === "existing"
            ? data.existingCustomer?.phone
            : data.phone,

        email: data.email,

        address: data.address,

        city: data.city,

        state: data.state,

        country: data.country,

        company: data.company,

        source: data.source?.value,

        industry_type_id: data.industry?.value,

        assigned_to: data.assignedTo?.value,

        status: data.status?.value,

        notes: data.notes,
      };

      const response = await postDataWithToken(
        updateEnquiry,
        postRequest
      );

      if (response?.data?.status === true) {
        toast.success("Enquiry updated successfully");

        navigate(`${process.env.PUBLIC_URL}/lead-manage/enquiry`);
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }

    setLoading(false);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Edit Enquiry"
        parent="Lead Manager"
        title="Edit Enquiry"
      />

      <Card>
        <CardHeader className="pb-0">
          <H3>Edit Enquiry</H3>
        </CardHeader>

        <CardBody>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row className="g-3">

              {/* Customer Type */}
              <Col md="6">
                <Label className="form-label">
                  Customer Type
                </Label>

                <Select
                  options={customerTypeOptions}
                  value={customerTypeOptions.find(
                    (item) => item.value === customerType
                  )}
                  onChange={(selected) => {
                    setCustomerType(selected.value);
                  }}
                />
              </Col>

              {/* Industry */}
              <Col md="6">
                <Label className="form-label">
                  Industry <span className="requireStar">*</span>
                </Label>

                <IndustryFilter
                  IsIndustry={selectedIndustry}
                  setIsIndustry={(value) => {
                    setSelectedIndustry(value);

                    setValue("industry", value);

                    getUsersList(value?.value);
                  }}
                />

                <span className="text-danger">
                  {errors.industry?.message}
                </span>
              </Col>

              {/* Name / Existing Customer */}
              {customerType === "new" ? (
                <Col md="6">
                  <Label className="form-label">
                    Name <span className="requireStar">*</span>
                  </Label>

                  <input
                    className="form-control"
                    type="text"
                    placeholder="Enter Name"
                    {...register("name")}
                  />

                  <span className="text-danger">
                    {errors.name?.message}
                  </span>
                </Col>
              ) : (
                <Col md="6">
                  <Label className="form-label">
                    Existing Customer
                  </Label>

                  <Controller
                    name="existingCustomer"
                    control={control}
                    render={({ field }) => (
                      <Typeahead
                        options={userOption}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                </Col>
              )}

              {/* Mobile */}
              {customerType === "new" && (
                <Col md="6">
                  <Label className="form-label">
                    Mobile <span className="requireStar">*</span>
                  </Label>

                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                      <PhoneInput
                        country={"in"}
                        value={field.value}
                        onChange={(value, country) => {
                          field.onChange(value);

                          setValue(
                            "country_code",
                            `+${country.dialCode}`
                          );

                          setValue("country", country.name);

                          const selected =
                            Country.getAllCountries().find(
                              (c) =>
                                c.phonecode === country.dialCode
                            );

                          if (selected) {
                            setSelectedCountry(selected);

                            const states =
                              State.getStatesOfCountry(
                                selected.isoCode
                              );

                            const formattedStates =
                              states.map((item) => ({
                                label: item.name,
                                value: item.name,
                              }));

                            setStateOptions(formattedStates);

                            setValue("state", "");
                          }
                        }}
                        enableSearch
                        inputStyle={{
                          width: "100%",
                          height: "38px",
                        }}
                      />
                    )}
                  />

                  <span className="text-danger">
                    {errors.phone?.message}
                  </span>
                </Col>
              )}

              {/* Email */}
              <Col md="6">
                <Label className="form-label">Email</Label>

                <input
                  className="form-control"
                  type="email"
                  placeholder="Enter Email"
                  {...register("email")}
                />
              </Col>

              {/* Source */}
              <Col md="6">
                <Label className="form-label">
                  Source <span className="requireStar">*</span>
                </Label>

                <Controller
                  name="source"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={sourceOptions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />

                <span className="text-danger">
                  {errors.source?.message}
                </span>
              </Col>

              {/* Company */}
              <Col md="6">
                <Label className="form-label">Company</Label>

                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter Company"
                  {...register("company")}
                />
              </Col>

              {/* Assigned User */}
              <Col md="6">
                <Label className="form-label">Assigned User</Label>

                <Controller
                  name="assignedTo"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={staffOptions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />
              </Col>

              {/* Status */}
              {/* <Col md="6">
                <Label className="form-label">Status</Label>

                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={enquiryStatusOptions}
                      value={field.value}
                      onChange={field.onChange}
                    />
                  )}
                />
              </Col> */}

              {/* Country */}
              <Col md="6">
                <Label className="form-label">Country</Label>

                <Controller
                  name="country"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={Country.getAllCountries()}
                      getOptionLabel={(opt) => opt.name}
                      getOptionValue={(opt) => opt.name}
                      value={selectedCountry}
                      onChange={(item) => {
                        setSelectedCountry(item);

                        field.onChange(item.name);

                        setValue(
                          "country_code",
                          `+${item.phonecode}`
                        );

                        const states =
                          State.getStatesOfCountry(
                            item.isoCode
                          );

                        const formattedStates =
                          states.map((state) => ({
                            label: state.name,
                            value: state.name,
                          }));

                        setStateOptions(formattedStates);

                        setValue("state", "");
                      }}
                    />
                  )}
                />
              </Col>

              {/* State */}
              <Col md="6">
                <Label className="form-label">State</Label>

                <Controller
                  name="state"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={stateOptions}
                      value={
                        stateOptions.find(
                          (item) =>
                            item.value === field.value
                        ) || null
                      }
                      onChange={(selected) =>
                        field.onChange(selected?.value)
                      }
                    />
                  )}
                />
              </Col>

              {/* City */}
              <Col md="6">
                <Label className="form-label">City</Label>

                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter City"
                  {...register("city")}
                />
              </Col>

              {/* Address */}
              <Col md="6">
                <Label className="form-label">Address</Label>

                <textarea
                  className="form-control"
                  rows="2"
                  placeholder="Enter Address"
                  {...register("address")}
                />
              </Col>

              {/* Notes */}
              <Col md="6">
                <Label className="form-label">Notes</Label>

                <textarea
                  className="form-control"
                  rows="2"
                  placeholder="Enter Notes"
                  {...register("notes")}
                />
              </Col>

            </Row>

            <Btn
              attrBtn={{
                color: "primary",
                className: "mt-4",
              }}
              type="submit"
            >
              Update Enquiry
            </Btn>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default EditEnquiry;